export const RoutePaths = {
  Core: {
    path: '',
    absolutePath: '/',
    Partners: {
      path: 'partners',
      absolutePath: '/partners'
    },
    Release: {
      path: 'release',
      absolutePath: '/release'
    },
    Entertainment: {
      path: 'entertainment',
      absolutePath: '/entertainment',
      LiveTv: {
        path: 'live-tv',
        absolutePath: '/entertainment/live-tv'
      },
      Movie: {
        path: 'movies',
        absolutePath: '/entertainment/movies'
      },
      Series: {
        path: 'series',
        absolutePath: '/entertainment/series'
      },
      Music: {
        path: 'music',
        absolutePath: '/entertainment/music'
      },
      Radio: {
        path: 'radio',
        absolutePath: '/entertainment/radio'
      },
      Playlists: {
        path: 'playlists',
        absolutePath: '/entertainment/playlists'
      }
    },
    DigitalSignage: {
      path: 'digital-signage',
      absolutePath: '/digital-signage',
      Devices: {
        path: 'devices',
        absolutePath: '/digital-signage/devices'
      },
      Screens: {
        path: 'screens',
        absolutePath: '/digital-signage/screens'
      },
      Events: {
        path: 'events',
        absolutePath: '/digital-signage/events'
      },
      Playlists: {
        path: 'playlists',
        absolutePath: '/digital-signage/playlists'
      },
      DeviceGroups: {
        path: 'device-groups',
        absolutePath: '/digital-signage/device-groups'
      }
    },
    RoomDevices: {
      path: 'room-devices',
      absolutePath: '/room-devices'
    },
    AppBuilder: {
      path: 'app-builder',
      absolutePath: '/app-builder',
      TvBranding: {
        path: 'tv-branding',
        absolutePath: '/app-builder/tv-branding'
      },
      TabletBranding: {
        path: 'tablet-branding',
        absolutePath: '/app-builder/tablet-branding'
      },
      MobileBranding: {
        path: 'mobile-branding',
        absolutePath: '/app-builder/mobile-branding'
      },
      CaptivePortal: {
        path: 'captive-portal',
        absolutePath: '/app-builder/captive-portal'
      }
    },
    Casting: {
      path: 'casting',
      absolutePath: '/casting'
    },
    HotelWifi: {
      path: 'hotel-wifi',
      absolutePath: '/hotel-wifi',
      Overview: {
        path: 'overview',
        absolutePath: '/hotel-wifi/overview'
      },
      BandwidthTiers: {
        path: 'bandwidth-tiers',
        absolutePath: '/hotel-wifi/bandwidth-tiers'
      },
      Guests: {
        path: 'guests',
        absolutePath: '/hotel-wifi/guests'
      },
      Sessions: {
        path: 'sessions',
        absolutePath: '/hotel-wifi/sessions'
      },
      TierHistory: {
        path: 'tier-history',
        absolutePath: '/hotel-wifi/tier-history'
      }
    },
    HotelWifiSettings: {
      path: 'settings/hotel-wifi',
      absolutePath: '/settings/hotel-wifi'
    },
    AiSettings: {
      path: 'settings/ai-concierge',
      absolutePath: '/settings/ai-concierge',
      General: {
        path: 'general',
        absolutePath: '/settings/ai-concierge/general'
      },
      Capabilities: {
        path: 'capabilities',
        absolutePath: '/settings/ai-concierge/capabilities'
      },
      Faq: {
        path: 'faq',
        absolutePath: '/settings/ai-concierge/faq'
      }
    },
    RoomsAssign: {
      path: 'rooms-assign',
      absolutePath: '/rooms-assign'
    },
    Settings: {
      path: 'settings',
      absolutePath: '/settings'
    },
    Organization: {
      path: 'settings/organization',
      absolutePath: '/settings/organization',
      General: {
        path: 'general',
        absolutePath: '/settings/organization/general'
      },
      Branding: {
        path: 'branding',
        absolutePath: '/settings/organization/branding'
      },
      ApiKey: {
        path: 'api-key',
        absolutePath: '/settings/organization/api-key'
      }
    },
    Analytics: {
      path: 'analytics',
      absolutePath: '/analytics',
      Orders: {
        path: 'orders',
        absolutePath: '/analytics/orders'
      },
      Services: {
        path: 'services',
        absolutePath: '/analytics/services'
      },
      Guests: {
        path: 'guests',
        absolutePath: '/analytics/guests'
      },
      Platforms: {
        path: 'platforms',
        absolutePath: '/analytics/platforms'
      },
      AiConcierge: {
        path: 'ai-concierge',
        absolutePath: '/analytics/ai-concierge'
      }
    },
    OrganizationInfo: {
      path: 'organization-info',
      absolutePath: '/organization-info'
    },
    InfoCenter: {
      path: 'settings/info-center',
      absolutePath: '/settings/info-center',
      Categories: {
        path: 'categories',
        absolutePath: '/settings/info-center/categories'
      },
      Informations: {
        path: 'informations',
        absolutePath: '/settings/info-center/informations'
      }
    },
    Integrations: {
      path: 'settings/integrations',
      absolutePath: '/settings/integrations',
      AllIntegrations: {
        path: 'all-integrations',
        absolutePath: '/settings/integrations/all-integrations'
      },
      HotelProducts: {
        path: 'hotel-products',
        absolutePath: '/settings/integrations/hotel-products'
      }
    },
    DepartmentsAndUnits: {
      path: 'settings/departments-and-units',
      absolutePath: '/settings/departments-and-units',
      Departments: {
        path: 'departments',
        absolutePath: '/settings/departments-and-units/departments'
      },
      Units: {
        path: 'units',
        absolutePath: '/settings/departments-and-units/units'
      }
    },
    HotelStaff: {
      path: 'settings/hotel-staff',
      absolutePath: '/settings/hotel-staff'
    },
    HotelManagement: {
      path: 'hotel-management',
      absolutePath: '/hotel-management'
    },
    Applications: {
      path: 'settings/applications',
      absolutePath: '/settings/applications'
    },
    Profile: {
      path: 'profile',
      absolutePath: '/profile'
    },
    Languages: {
      path: 'settings/languages',
      absolutePath: '/settings/languages'
    },
    DesktopApp: {
      path: 'settings/desktop-app',
      absolutePath: '/settings/desktop-app'
    },
    InternalServersConfiguration: {
      path: 'settings/internal-servers-configuration',
      absolutePath: '/settings/internal-servers-configuration'
    },
    NotificationsSettings: {
      path: 'settings/notifications-settings',
      absolutePath: '/settings/notifications-settings'
    },
    Help: {
      path: 'help',
      absolutePath: '/help'
    },
    ContactUs: {
      path: 'contact-us',
      absolutePath: '/contact-us'
    },
    Promotions: {
      path: 'promotions',
      absolutePath: '/promotions'
    },
    Products: {
      path: 'products',
      absolutePath: '/products'
    },
    Services: {
      path: 'services',
      absolutePath: '/services'
    },
    Orders: {
      path: 'orders',
      absolutePath: '/orders'
    },
    ProductCategories: {
      path: 'product-categories',
      absolutePath: '/product-categories'
    },
    ServiceReservation: {
      path: 'service-requests',
      absolutePath: '/service-requests'
    },
    Sales: {
      path: 'sales',
      absolutePath: '/sales',
      Orders: {
        path: 'orders',
        absolutePath: '/sales/orders'
      },
      ServiceReservation: {
        path: 'service-requests',
        absolutePath: '/sales/service-requests'
      }
    },
    Catalog: {
      path: 'catalog',
      absolutePath: '/catalog',
      Products: {
        path: 'products',
        absolutePath: '/catalog/products'
      },
      ProductCategories: {
        path: 'product-categories',
        absolutePath: '/catalog/product-categories'
      },
      Services: {
        path: 'services',
        absolutePath: '/catalog/services'
      }
    }
  },
  AppBuilderWeb: {
    path: 'app-builder-web',
    absolutePath: '/app-builder-web',
    TvBranding: {
      path: 'tv-branding',
      absolutePath: '/app-builder-web/tv-branding'
    },
    TabletBranding: {
      path: 'tablet-branding',
      absolutePath: '/app-builder-web/tablet-branding'
    },
    MobileBranding: {
      path: 'mobile-branding',
      absolutePath: '/app-builder-web/mobile-branding'
    }
  },
  VerifyBeforePasswordChange: {
    path: 'verify-password',
    absolutePath: '/verify-password'
  },
  ChangePassword: {
    path: 'change-password',
    absolutePath: '/change-password'
  },
  Auth: {
    path: 'auth',
    absolutePath: '/auth',
    SignUp: {
      path: 'register',
      absolutePath: '/auth/register'
    },
    SignIn: {
      path: 'login',
      absolutePath: '/auth/login'
    },
    ForgotPassword: {
      path: 'forgot-password',
      absolutePath: '/auth/forgot-password'
    },
    ResetPassword: {
      path: 'reset-password',
      absolutePath: '/auth/reset-password'
    }
  },
  UiKit: {
    path: 'ui-kit',
    absolutePath: '/ui-kit'
  }
};
